export const VDataTable = {
    props: {
        'input':{
            type: Array,
            required: false,
            default: function () {
                return undefined
            }
        },
    },
    data() {
        return {
            // Items marked with a * can/should be specified on the component
            items: this.input || null,           // REQUIRED: An array of data.  Each element represents one row to be drawn into the data table
            endpoint_uri: null,                // *REQUIRED if no input prop is passed: The URI for retrieving records for the list
            endpoint_method: 'GET',            // *HTTP Request method used when retrieving records for the list
            infiniteScroll: false,        // *Will allow for fetching more records automatically when scrolling to the bottom of the screen
            search: '',                   // The current search criteria
            hideDefaultFooter: null,      // Used to automatically hide the default table footer when in infinite scroll mode
            loading: false,            // Indicates whether or not a AJAX call is still in progress
            options: {},               // This contains information about the number of rows per page, what page we're on, sort info etc.  This should be syncd with the options from the actual v-data-table


            // These are properties that would be marked as private in most programming environments
            serverSide: true,          // Determines if data is to be fetched via AJAX calls (if not, it should be passed in as the input prop)
            foundCount: 0,             // The total number of records matching your current search criteria
            draw: 0,                   // The number of times we've requested data for the table
            awaitingSearch: false,     // Indicates if the user is still typing in their search criteria
            endOfData: false,          // Can signify that there is no more data available to fetch
            requestPayloadType: 'spatie',    // In ('homebrew', 'spatie')
        }
    },
    methods: {
        async getData() {
            if (!this.serverSide){
                return
            }
            try {
                this.ajaxPrerequisiteCheck()
                // Initialize state

                if (!this.loading) {
                    this.draw++
                    this.loading = true
                    let response = null

                    // Make AJAX call using appropriate method, assign results to response
                    if (this.endpoint_method == 'POST') {
                        response = await axios.post(this.endpoint_uri, this.tableState())        // Syntax is nicer when written for POST
                    } else {
                        response = await axios.get(this.endpoint_uri, {params: this.tableState()})  // Has to be written kind of awkwardly for GET
                    }

                    // Ensure that we only update state with data received from the latest call, and again update state
                    if (response.data.draw === this.draw) {
                        this.loading = false
                        this.addDataToTable(response.data)
                    }
                }

            }
            catch (error) {
                console.log(error)
            }

        },
        checkIfServerSide() { // Assume that data is to be collected server-side unless input was passed
            this.serverSide = typeof this.input === 'undefined'
        },
        checkForInfiniteScroll() {
            // Infinite scroll currently only works when loading data server-side
            this.infiniteScroll = this.serverSide ? this.infiniteScroll : false
            // Hide the default footers when infinite scroll is enabled
            if (this.infiniteScroll) {
                this.hideDefaultFooter = true
            } else{
                this.hideDefaultFooter = undefined
            }
        },
        sortOrder() {
            // Creates a new object to send to the server so that it knows how to sort
            let sort_criteria = []
            this.options.sortBy.forEach((element, index) => {
                let matchingHeader = this.headers.find(possibleMatch => possibleMatch.value === element)
                if (matchingHeader && matchingHeader.sortable) {
                    if(this.requestPayloadType == "spatie") {
                        sort_criteria.push((this.options.sortDesc[index] ? '-' : '') + matchingHeader.value)
                    } else {
                        sort_criteria.push({
                            column: matchingHeader.value,
                            dir: (this.options.sortDesc[index] ? 'DESC' : 'ASC')
                        })
                    }
                }
            })
            if(this.requestPayloadType == "spatie") {
                return sort_criteria.join(',');
            } else {
                return sort_criteria
            }
        },
        tableState() {
            // This returns the payload that will be sent to the server when querying for data

            let payload = null
            switch (this.requestPayloadType) {
                case "spatie":
                    payload = {
                        draw: this.draw,
                        page: {number: this.options.page, size:this.options.itemsPerPage},
                        filter: {},
                        sort: this.sortOrder(),
                    }
                    if(this.search != "" && this.search != null) {
                        payload.filter["search"] = this.search;
                    }
                    this.headers.forEach((header_item, index) => {
                        if (header_item.search != "" && header_item.search != null) {
                            payload.filter[header_item.value] = header_item.search;
                        }
                    })

                    break;
                default:
                    payload = {
                        options: this.options,
                        headers: this.headers,
                        search: this.search,
                        draw: this.draw,
                        order: this.sortOrder(),
                    }
                    break
            }
            return payload
        },
        ajaxPrerequisiteCheck() {
            // Check for required values before sending an AJAX request
            if (!this.headers){
                throw 'Please make sure you provide headers'
            }
            if (this.serverSide && !this.endpoint_uri){
                throw 'Please make sure you provide endpoint_uri'
            }
        },
        addDataToTable(dataToAdd) {
            // Add data to the array that drives the data table

            // How we handle the response data depends on whether or not infinite scrolling is in effect
            if (!this.infiniteScroll) {
                // Empty data out of 'items' property before continuing
                this.clearList()
            }

            let updateWasSuccessful = false //
            dataToAdd.data.forEach(newItem => {
                if (!this.items.find(existingItem=>existingItem.id === newItem.id)){
                    // Push the item into the list
                    this.items.push(newItem)
                    updateWasSuccessful = true
                }
                else {
                    // This item is a duplicate, do not push it
                }
            })
            if (!this.infiniteScroll || !this.items.length){
                this.foundCount = dataToAdd.recordsFiltered
            } else {
                this.foundCount += dataToAdd.recordsFiltered
            }
            if (this.infiniteScroll){
                if (updateWasSuccessful){
                    this.options.page++
                }
                else {
                    this.endOfData = true
                }
            }
        },
        isInfiniteScrollOptionChange(newVal, oldVal) {
            if (!Object.entries(oldVal).length){    // There probably won't be an oldVal on first load
                return false
            }

            // We need to modify newVal and oldVal, so we should do so non-destructively.  Modify clones instead
            let newVal2 = structuredClone(newVal)
            let oldVal2 = structuredClone(oldVal)
            delete newVal2.page
            delete oldVal2.page

            // If the clones without page# options are the same, then we know that regular options had not changed
            return this.infiniteScroll && (JSON.stringify(newVal2) !== JSON.stringify(oldVal2))
        },
        clearList() {
            this.items.splice(0, this.items.length)
        },
        debouncedSearch: _.debounce(function () {
            if (this.infiniteScroll){
                this.clearList()
            }
            this.options.page = 1       // Brings us back to page #1
            this.getData()              // Updates data to match new search criteria
        }, 666),

        debouncedScroll: _.debounce(function () {
            let bottomOfWindow = document.documentElement.scrollTop + window.innerHeight === document.documentElement.offsetHeight
            if (this.infiniteScroll && !this.endOfData){
                // User is trying to scroll, and as far as we know, there is probably more data available for us on the server
                if (bottomOfWindow) {
                    this.getData()
                }
            } else if (this.infiniteScroll && this.endOfData) {
                // User is trying to scroll, but we're pretty sure there is no more data available for them
                if (!bottomOfWindow){
                    // If we're not at the bottom of the window even though we're at the end of data, then the user is probably trying to scroll back up
                    this.endOfData = false
                }
            }
        }, 10),
    },
    mounted() {
        this.checkIfServerSide()
        this.checkForInfiniteScroll()
        // this.getData()           // I used to force it to getData here, but it would seem I do not need to.
    },
    computed: {
        serverItemsLength: function () {
          return this.serverSide ? this.foundCount : undefined
        },
    },
    watch: {
        options: {  // Fetch new data whenever the options for the datatable are updated (this includes itemsPerPage, pageNumber, sort order, etc...)
            handler(newVal, oldVal) {
                if (newVal != oldVal) {
                    if (this.isInfiniteScrollOptionChange(newVal, oldVal)){
                        this.clearList()
                    }
                    this.getData()
                }
            },
            deep: true
        },
        search: {
            handler(newVal, oldVal) {
                this.debouncedSearch()
            }
        }
    },
}
